<template>
  <div class="info-box-wrapper" v-if="visible">
    <div class="info-box-toggle" @click="closeBox">
      <font-awesome-icon icon="times"/>
    </div>
    <div class="info-box-content d-flex flex-column align-items-start">
      <div class="d-flex justify-content-center align-items-center mb-3">
        <font-awesome-icon class="mr-2" icon="desktop"/>
        <span>{{ vueVersion + ' '}}</span>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <font-awesome-icon class="mr-2" icon="server"/>
        <span>{{ apiVersion }}</span>
      </div>
    </div>
    <div class="info-box-text">
      For more information or technical support, contact us at +1 xxx.xxx.xxx
    </div>
    <div class="info-box-buttons">
      <a :href="'mailto:' + supportEmail">
        <button class="button blue-btn">
          EMAIL SUPPORT
        </button>
      </a>
      <button @click="closeBox" class="button blue-btn">
        CLOSE
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generalGetters from '../../store/modules/general/getterTypes'

export default {
  name: 'ApplicationInfoBox',
  data () {
    return {
      visible: false,
      vueVersion: process.env.VUE_APP_COMMIT_TAG || 'No commit set',
      supportEmail: 'gitlab+symrise-symrise-324-issue-@zettafox.com'
    }
  },
  computed: {
    ...mapGetters({
      apiVersion: generalGetters.GET_API_VERSION
    })
  },
  methods: {
    openBox () {
      this.visible = true
    },
    closeBox () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.info-box-wrapper {
  background: #FFFFFF;
  border: 2px solid #999999;
  border-radius: 6px;
  width: 680px;
  height: 312px;
  position: fixed;
  bottom: 96px;
  right: 87px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000 !important;

  .info-box-toggle {
    position: absolute;
    top: 28px;
    right: 32px;
    cursor: pointer;
  }

  .info-box-content {
    width: 568px;
    height: 80px;
    text-align: left;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 900;
    letter-spacing: 0;
  }

  .info-box-text {
    width: 568px;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 13px;
    line-height: 23px;
    letter-spacing: 0;
  }

  .info-box-buttons {
    width: 568px;
    height: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    .button {
      border-radius: 6px;
      width: 152px;
      height: 40px;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 900;
      font-size: 11px;
      line-height: 20px;
      letter-spacing: 0;
    }

    .blue-btn {
      color: white;
      background: $blueberry 0 0 no-repeat padding-box;
      border: 1px solid #17469E;
      margin-left: 29px;

      transition: background-color 0.2s linear;
      &:hover {
        background-color: #9256D9;
      }
    }
  }
}
</style>
